import React from 'react';
import { Box, SpaceBetween, StatusIndicator } from '@cloudscape-design/components';

export default function RecordedDecision({ title, description, note, noteLabel = 'Decision Maker note', decidedAt, decidedBy }) {
  const date = decidedAt ? new Date(decidedAt) : null;
  return <SpaceBetween size="s">
    <StatusIndicator type="success">{title}</StatusIndicator>
    {(decidedBy || (date && !Number.isNaN(date.getTime()))) && <Box color="text-body-secondary">
      {decidedBy ? `Recorded by ${decidedBy}` : 'Recorded'}
      {date && !Number.isNaN(date.getTime()) ? ` · ${date.toLocaleString('en-CA', { dateStyle: 'medium', timeStyle: 'short' })}` : ''}
    </Box>}
    {description && <Box>{description}</Box>}
    {note?.trim() && <div>
      {noteLabel && <Box fontWeight="bold">{noteLabel}</Box>}
      <Box whiteSpace="pre-wrap">{note}</Box>
    </div>}
  </SpaceBetween>;
}
